import { SkeletonLoader } from '@design/components/skeleton-loader/SkeletonLoader';
import { ErrorMessageWrapper } from '@terminal/components/error-message-wrapper/ErrorMessageWrapper';
import { useEntities } from '@terminal/react-query-hooks/entities/useEntities';
import { KnowledgeGraph } from '@terminal/views/theme-overview/tab-content/companies/knowledge-graph/KnowledgeGraph';
import styles from './MSCompanies.module.scss';

export const MSCompanies = ({ theme }: { theme: any }) => {
  const entityTags = theme.constituents.map(
    (constituent: any) => constituent.entity_tag
  );

  const { data: dataEntities, isLoading } = useEntities({
    entityTags,
    appendFetching: true,
  });

  const getContent = () => {
    if (isLoading) {
      return (
        <div className={styles.skeletonLoaderWrapper}>
          <SkeletonLoader
            data-testid="companies-loading"
            areas={[
              {
                styles: {
                  width: '100%',
                  height: '100%',
                  borderRadius: '8px',
                },
              },
            ]}
          />
        </div>
      );
    }

    const companyTableData = dataEntities.map((entity, idx) => ({
      ...entity,
      company: entity.tag,
      relationship: {
        rank: idx + 1,
      },
    }));

    if (!companyTableData?.length) {
      return (
        <div>
          <ErrorMessageWrapper
            variant="empty"
            displayIcon
            data-testid="companies-empty"
          />
        </div>
      );
    }

    return (
      <main className={styles.mainContent}>
        <div className={styles.viewContainer}>
          <div className={styles.headerWrapper}>
            {/* @ts-expect-error */}
            <KnowledgeGraph data={companyTableData} theme={theme} />
          </div>
        </div>
      </main>
    );
  };

  return (
    <div
      className={styles.companiesRoot}
      data-testid="theme-overview-companies-tab"
    >
      <div className={styles.container}>{getContent()}</div>
    </div>
  );
};
